import { Injectable } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { ApiEndpoints } from './../../shared/services/api-endpoints.service';
import { CookieService } from 'ngx-cookie-service';
import { JwtDecoder } from './auth/jwt-decoder.service';

@Injectable()
export class LoginService {
  public redirectUrl: string;

  constructor(
    private router: Router,
    private apiEndpoints: ApiEndpoints,
    private cookie: CookieService,
    private jwtDecoder: JwtDecoder,
  ) {}

  initAuth(data) {
    return this.apiEndpoints.post('login', data);
  }

  checkToken() {
    var roleArray = [];
    if (this.jwtDecoder.getUserInformation()) {
      // if(this.jwtDecoder.getUserInformation().user.role){
      //   roleArray = this.jwtDecoder.getUserInformation().user.role.split(',');
      //   if(roleArray[0].toLowerCase() === 'agent' || (roleArray[1] && roleArray[1].toLowerCase() === 'agent')){
      //     return true;
      //   }
      // }
      return true;
    }
    return false;
  }

  saveRedirectUrl(url) {
    this.redirectUrl = url;
  }
  checkRedirectLink() {
    if (this.redirectUrl) {
      return this.redirectUrl;
    } else {
      return '';
    }
  }

  getTokenObject() {
    if (this.jwtDecoder.getUserInformation()) {
      return this.jwtDecoder.getUserInformation().user || false;
    }
    return false;
  }

  injectToken(token) {
    let date = new Date();
    date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
    let domain = this.apiEndpoints.fetchBaseDomainName();
    this.cookie.set('squanchy', token, date, '/', `${domain}`);
  }

  refreshToken(data) {
    return this.apiEndpoints.nulledPost('refreshToken', {
      token: data.user_token,
      user_id: data.user_id,
    });
  }
}
